export default "__VITE_ASSET__3rmRV9pd__"